import React from 'react'
import milanBlackAnimation from '../json/milan-black.json'
import Lottie from 'lottie-web'

import Superface from '../Superface'

class LoadingAnimation extends React.Component {
    
    
    componentDidMount(){

        this.animationBlack = Lottie.loadAnimation(
            {...this.options, container : this.containerBlack, animationData : milanBlackAnimation }
        )
        
    }

    
    

    

    render(){
        let style = { width:'100%', height:'100%', position : 'absolute', zIndex:1352, display:'flex', justifyContent:'center', alignItems:'center'}
        let animStyles = {width:'150px', height:'150px', position : 'absolute', padding : '5px'}
        
        return(
            <div style={style}>
                <div style={{...animStyles }} ref={ containerBlack => { this.containerBlack = containerBlack }}></div>
            </div>
        )
    }
}

export default LoadingAnimation



// WEBPACK FOOTER //
// ./src/components/_LoadingAnimation.js